<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';

// Split layout for TalkRobin auth pages: form on the left, the dark brand
// panel (slot "aside") on the right from large screens up.
const store = useStore();
const { t } = useI18n();

const globalConfig = computed(() => store.getters['globalConfig/get']);
// The marketing site, set as BRAND_URL in the installation config.
const siteUrl = computed(() => window.globalConfig?.BRAND_URL || '');
const year = new Date().getFullYear();
</script>

<template>
  <main
    class="flex w-full min-h-screen bg-white font-inter dark:bg-robin-navy"
  >
    <div class="flex flex-col flex-1 min-w-0 px-6 py-7 sm:px-10 xl:px-16">
      <header class="flex items-center justify-between gap-4">
        <component
          :is="siteUrl ? 'a' : 'span'"
          :href="siteUrl || undefined"
          class="inline-flex"
        >
          <img
            :src="globalConfig.logo"
            :alt="globalConfig.installationName"
            class="block w-auto h-8 dark:hidden"
          />
          <img
            :src="globalConfig.logoDark || globalConfig.logo"
            :alt="globalConfig.installationName"
            class="hidden w-auto h-8 dark:block"
          />
        </component>
        <div class="text-sm text-robin-slate dark:text-n-slate-11">
          <slot name="header" />
        </div>
      </header>

      <div class="flex items-center justify-center flex-1 py-12">
        <div class="w-full max-w-[420px]">
          <slot />
        </div>
      </div>

      <footer
        class="flex flex-wrap items-center gap-x-5 gap-y-1 text-xs text-robin-slate dark:text-n-slate-10"
      >
        <span>{{ t('TALKROBIN_AUTH.FOOTER.COPYRIGHT', { year }) }}</span>
        <a
          v-if="globalConfig.privacyURL"
          :href="globalConfig.privacyURL"
          target="_blank"
          rel="noopener noreferrer"
          class="hover:text-robin-indigo"
        >
          {{ t('TALKROBIN_AUTH.FOOTER.PRIVACY') }}
        </a>
        <a
          v-if="globalConfig.termsURL"
          :href="globalConfig.termsURL"
          target="_blank"
          rel="noopener noreferrer"
          class="hover:text-robin-indigo"
        >
          {{ t('TALKROBIN_AUTH.FOOTER.TERMS') }}
        </a>
      </footer>
    </div>

    <aside
      v-if="$slots.aside"
      class="sticky top-0 hidden h-screen p-3 lg:flex lg:w-[48%] xl:w-[52%] max-w-[860px]"
    >
      <slot name="aside" />
    </aside>
  </main>
</template>
